import React, { useEffect, useCallback, useRef, useState } from 'react';
import webStorage from '@/utils/storageManager';
// import CardList from './components/card_list/CardList';
import { useLocation, history, useDispatch, useIntl } from 'umi';
import qs from 'qs';
import CardListML from '@/components/CardListML';
import ResultList from './components/result_list/ResultList';
import dayjs from 'dayjs';
import SearchGroup from './components/search_group/SearchGroup';
import { Box } from '@material-ui/core';

export default () => {
  const userAuths = webStorage.get('USER')?.authorities;
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const location = useLocation();
  const searchRef = useRef();
  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const {
    title,
    status,
    type,
    usedType,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;
  const [isSearch, setIsSearch] = useState(false);
  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //运营列表
  const fetchCouponList = useCallback(() => {
    const values = {
      title,
      status,
      type,
      usedType,
      refreshTime,
      pageNum,
      pageSize,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    dispatch({
      type: 'operateList/getOperateList',
      payload: {
        values,
      },
    });
  }, [title, status, type, usedType, pageNum, pageSize, dispatch, refreshTime]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);
  //卡片列表经销商前面三个没有
  const tenantId = webStorage.get('TENANT_ID');

  const cardList =
    tenantId === '10000'
      ? [
          {
            cardTitle: formatMessage({ id: 'marketing.people.n01.lbl01' }),
            cardType: 'REGISTERED_UNPAID',
            cardDesc: [
              formatMessage({ id: 'marketing.people.n01.txt02' }),
              formatMessage({ id: 'marketing.people.n01.txt03' }),
            ],
            imgUrl: require('@/assets/img/shoes_three.jpg'),
            linkTo: 'registered_unpaid',
            oid: 'btn_marketing_activity_user_operation_list_create_unpaid_registration',
            disabled: true,
          },
          {
            cardTitle: formatMessage({ id: 'marketing.people.n02.lbl01' }),
            cardType: 'KEY_RECALL',
            cardDesc: [
              formatMessage({ id: 'marketing.people.n02.txt02' }),
              formatMessage({ id: 'marketing.people.n02.txt03' }),
            ],
            imgUrl: require('@/assets/img/shoes_two.jpg'),
            linkTo: 'key_recall',
            oid: 'btn_marketing_activity_user_operation_list_create_focus_recall_users',
            disabled: true,
          },
          {
            cardTitle: formatMessage({ id: 'marketing.people.n03.lbl01' }), //自定义人群
            cardType: 'CUSTOM_CROWD',
            cardDesc: [
              formatMessage({ id: 'marketing.people.n03.txt02' }),
              formatMessage({ id: 'marketing.people.n03.txt03' }),
            ],
            imgUrl: require('@/assets/img/shoes_one.jpg'),
            linkTo: 'custom_crowd',
            oid: 'btn_marketing_activity_user_operation_list_create_customized_audience',
            disabled: !userAuths.includes('MENU_MARKETING_CROWD_CUSTOM_CROWD'),
          },
          {
            cardTitle: formatMessage({ id: 'marketing.people.n04.lbl01' }), //指定手机号客户
            cardType: 'ASSIGN_TELEPHONE',
            cardDesc: [
              formatMessage({ id: 'marketing.people.n04.txt02' }),
              formatMessage({ id: 'marketing.people.n04.txt03' }),
            ],
            imgUrl: require('@/assets/img/shoes_four.jpg'),
            linkTo: 'assign_telephone',
            oid: 'btn_marketing_activity_user_operation_list_create_specified_mobile_customers',
            disabled: !userAuths.includes(
              'MENU_MARKETING_CROWD_ASSIGN_TELEPHONE',
            ),
          },
        ]
      : tenantId === '6679'
      ? [
          {
            cardTitle: formatMessage({ id: 'marketing.people.n03.lbl01' }), //自定义人群
            cardType: 'CUSTOM_CROWD',
            cardDesc: [
              formatMessage({ id: 'marketing.people.n03.txt02' }),
              formatMessage({ id: 'marketing.people.n03.txt03' }),
            ],
            imgUrl: require('@/assets/img/shoes_one.jpg'),
            linkTo: 'custom_crowd',
            disabled: !userAuths.includes('MENU_MARKETING_CROWD_CUSTOM_CROWD'),
          },
          {
            cardTitle: formatMessage({ id: 'marketing.people.n04.lbl01' }), //指定手机号客户
            cardType: 'ASSIGN_TELEPHONE',
            cardDesc: [
              formatMessage({ id: 'marketing.people.n04.txt02' }),
              formatMessage({ id: 'marketing.people.n04.txt03' }),
            ],
            imgUrl: require('@/assets/img/shoes_four.jpg'),
            linkTo: 'assign_telephone',
            disabled: !userAuths.includes(
              'MENU_MARKETING_CROWD_ASSIGN_TELEPHONE',
            ),
          },
        ]
      : [
          {
            cardTitle: formatMessage({ id: 'marketing.people.n04.lbl01' }), //指定手机号客户
            cardType: 'ASSIGN_TELEPHONE',
            cardDesc: [
              formatMessage({ id: 'marketing.people.n04.txt02' }),
              formatMessage({ id: 'marketing.people.n04.txt03' }),
            ],
            imgUrl: require('@/assets/img/shoes_four.jpg'),
            linkTo: 'assign_telephone',
            oid: 'btn_marketing_activity_user_operation_list_create_specified_mobile_customers',
            disabled: !userAuths.includes(
              'MENU_MARKETING_CROWD_ASSIGN_TELEPHONE',
            ),
          },
        ];
  //点击不同卡片传递不同参数
  const handleCardClick = (cardItem) => {
    history.push({
      pathname: `/marketing/crowd/${cardItem.linkTo}`,
      query: {
        cardType: cardItem.cardType,
        opt: 'add',
        sourceOid: cardItem.oid,
      },
    });
  };

  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_marketing_activity_user_operation_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <CardListML cardList={cardList} handleClick={handleCardClick} />
      <SearchGroup
        searchRef={searchRef}
        query={query}
        handleSearch={(par) => handleSearch(par)}
        restClick={handleRestClick}
      />
      <ResultList
        pageData={{ pageNum, pageSize }}
        handlePageChange={handlePageChange}
      />
    </Box>
  );
};
